'use client';

import { FC, Fragment } from 'react';
import DemoCard from '../demoCard/DemoCard';
import { ITheme } from '@/src/lib/types/themeInterface';
import styles from './ThemesList.module.scss';

type TList = {
  themesData: ITheme[];
  activeTag?: string;
  handleFilters?: (activeTag: string) => void;
};

const ThemesList: FC<TList> = ({ themesData, activeTag, handleFilters }) => {
  let index = -1;

  return (
      <ul className={styles.themes__list}>
        {themesData
            .filter(theme => theme.slug !== '')
            .map((item, i) => {
              const { demoList } = item;

              const filteredList =
                  demoList && activeTag
                      ? activeTag === 'All Categories'
                          ? demoList
                          : demoList.filter(demo => demo.demoTag === activeTag)
                      : demoList;

              return (
                  <Fragment key={`${item?._id}-${i}-${item?.title}`}>
                    {filteredList &&
                        filteredList.map((demo, i) => {
                          index += 1;
                          return (
                              <li key={`${demo?._key}-${i}-${item?._id}`}>
                                <DemoCard
                                    demoData={demo}
                                    theme={item}
                                    handleFilters={handleFilters}
                                    index={index}
                                />
                              </li>
                          );
                        })}
                  </Fragment>
              );
            })}
      </ul>
  );
};

export default ThemesList;
